import { render, staticRenderFns } from "./VerDevolucionItems.vue?vue&type=template&id=24706777&scoped=true&"
import script from "./VerDevolucionItems.vue?vue&type=script&lang=js&"
export * from "./VerDevolucionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24706777",
  null
  
)

export default component.exports